import { VIDEO_ACCEPT_LIMIT_BYTES, VIDEO_WIRE_LIMIT_BYTES } from "@/constants/file-picker"

export type AttachResult =
  | { ok: true }
  | { ok: false; reason: "cancelled"; filename: string }
  | { ok: false; reason: "unsupported"; filename: string }
  | { ok: false; reason: "container"; filename: string }
  | { ok: false; reason: "second-video"; filename: string; existingFilename: string }
  | { ok: false; reason: "over-accept-limit"; filename: string; sizeBytes: number }
  | { ok: false; reason: "compress-failed"; filename: string; sizeBytes: number; compressedBytes: number }
  | { ok: false; reason: "compression-error"; filename: string; sizeBytes: number }
  | { ok: false; reason: "ffmpeg-unavailable"; filename: string; sizeBytes: number }
  | { ok: false; reason: "no-compressor"; filename: string; sizeBytes: number }
  | { ok: false; reason: "wrong-surface"; filename: string }

const mb = (bytes: number) => Math.ceil(bytes / 1024 / 1024)

export function attachRefusalMessage(input: AttachResult) {
  if (input.ok) return undefined
  switch (input.reason) {
    case "cancelled":
    case "unsupported":
      return undefined
    case "container":
      return `Can't attach ${input.filename}. Video must be MP4, WebM, or MOV.`
    case "second-video":
      return `Only one video per message. Remove ${input.existingFilename} first.`
    case "over-accept-limit":
      return `${input.filename} is ${mb(input.sizeBytes)}MB. The limit is ${mb(VIDEO_ACCEPT_LIMIT_BYTES)}MB — trim it and try again.`
    case "no-compressor":
      return `${input.filename} is ${mb(input.sizeBytes)}MB. The limit here is ${mb(VIDEO_WIRE_LIMIT_BYTES)}MB — compress it and try again, or attach it from the desktop app.`
    case "compress-failed":
      return `${input.filename} is ${mb(input.sizeBytes)}MB and compressed to ${mb(input.compressedBytes)}MB, still over the ${mb(VIDEO_WIRE_LIMIT_BYTES)}MB limit. Trim it and try again.`
    case "compression-error":
      return `Couldn't compress ${input.filename} (${mb(input.sizeBytes)}MB). Compress it manually and try again.`
    case "ffmpeg-unavailable":
      return `${input.filename} is ${mb(input.sizeBytes)}MB, over the ${mb(VIDEO_WIRE_LIMIT_BYTES)}MB limit, and this build can't compress video. Compress it and try again.`
    case "wrong-surface":
      return "Videos can only be attached in the main composer."
    default: {
      const exhaustive: never = input
      throw new Error(`Unhandled attachment refusal: ${JSON.stringify(exhaustive)}`)
    }
  }
}
